import { initContract } from '@ts-rest/core';
import { z } from 'zod';

import { FindConditionsQuerySchema } from './reaction-conditions.schema';

const c = initContract();
const pathPrefix = '/reaction-conditions';

export const reactionConditionsContract = c.router(
  {
    classifyReaction: {
      method: 'GET',
      path: '/classify-reaction',
      query: z.object({
        reactionSmiles: z.string(),
      }),
      responses: {
        200: z.array(z.string()),
      },
    },
    findConditions: {
      method: 'GET',
      path: '/find',
      query: FindConditionsQuerySchema,
      responses: {
        200: z.object({
          conditions: z.any(),
        }),
      },
    },
  },
  {
    pathPrefix,
    validateResponseOnClient: true,
  }
);
